<div class="row w-100 mx-0 auth-page">
  <div class="col-md-8 col-xl-6 mx-auto">
    <div class="card mx-auto">
      <div
        class="auth-logo-wrapper"
        [ngStyle]="{ 'background-image': 'url(assets/images/logo.png)' }"
      ></div>

      <div class="auth-form-wrapper px-4 py-3">
        <!-- <a class="nobleui-logo d-block mb-2">Hei<span>Town</span></a> -->

        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
